/* Presentation only. Shopify owns the buttons, consent and preferences modal. */
(() => {
  if (window.tdtCookieBannerLabel) return;
  window.tdtCookieBannerLabel = true;
  const update = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;
    const lang = document.documentElement.lang.split('-')[0];
    const button = banner.querySelector('#shopify-pc__banner__btn-accept');
    const label = { es: 'Aceptar todas', en: 'Accept all' }[lang];
    // Change a text node only; preserve any native spans, icons and listeners.
    if (button && label) {
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.textContent.trim()) { if (node.textContent !== label) node.textContent = label; break; }
      }
    }
    const prefs = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (prefs && !prefs.hasAttribute('aria-label')) prefs.setAttribute('aria-label', prefs.textContent.trim());
  };
  update();
  // Native Shopify mounts the banner as a body child. Observe only that boundary.
  const observer = new MutationObserver(update);
  observer.observe(document.body, { childList: true });
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', () => { observer.observe(document.body, { childList: true }); update(); });
})();
